import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SortMenu } from '../../shared/models/sort-menu';
import { FilterMenu } from '../../shared/models/filter-menu';
import { PanelList } from '../../shared/models/panel-list';
import { DocumentTemplateManagementService } from '../services/document-template-management.service';
import { FileService } from '../../shared/services/file.service';
import { ConfirmationService } from 'primeng/api';
import { DocumentTemplateManagementConstants } from '../document-template-management-constants';
import { DocumentTemplateDetails } from '../models/document-template-details';
import { cloneDeep } from 'lodash-es';
import { DocumentTemplateManagementInteractionService } from '../services/document-template-management-interaction.service';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { CommonService } from '../../shared/services/common.service';



@Component({
  selector: 'app-document-template-global-list',
  templateUrl: './document-template-global-list.component.html',
  styleUrls: ['./document-template-global-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentTemplateGlobalListComponent implements OnInit {
  isDocumentTemplateSliderOpen = false;
  documentTemplates: DocumentTemplateDetails[] = [];
  documentTemplateToEdit!: DocumentTemplateDetails | undefined;
  isActiveValueYes = "Yes";
  isDocumentTemplatesLoaded: boolean = true;
  documentTemplatesModalInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false
  };
  scopeData:any;
  scopeList:any=[];
  isWhereAmIUsedModalVisible:boolean=false;
  whereAmIUsedList:any=[];
  showLoader: boolean = false;

  constructor(private documentTemplateManagementService: DocumentTemplateManagementService,
    private documentTemplateManagementInteractionService: DocumentTemplateManagementInteractionService,
    private fileService: FileService, private confirmationService: ConfirmationService,
    private eqmsScopeService:EqmsScopeManagementService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.getDocumentTemplates();
    this.getEqmsScopes();
    this.documentTemplateManagementInteractionService.documentTemplates$.subscribe((documentTemplates) => {
      if (documentTemplates.length > 0) {
        this.isDocumentTemplatesLoaded = false;
        this.bindDocumentTemplates(documentTemplates);
      }
    })
  }

  getEqmsScopes() {
    this.eqmsScopeService.geteQMSScopeLookup().subscribe((scopeData: any) => {
      scopeData.forEach((data: { eQMSScopeId: any; eQMSScopeName: any; })=>{
        this.scopeList.push({
          value:data.eQMSScopeId,
          name:data.eQMSScopeName,
          eqmsScopeId:data.eQMSScopeId
        })
      })
    })
  }

  openWhereAmIUsedModal = (documentTemplateId: any):void=>{
    this.documentTemplateManagementService.getLinkedeQMSScopes(documentTemplateId).subscribe(response=>
      {
        if(response.eQMSScopes != undefined && response.eQMSScopes.length > 0){
          response.eQMSScopes.forEach((eqmsScope:any) => {
            this.scopeList.filter((scope: any) => {
              if(scope.eqmsScopeId==eqmsScope){
                this.whereAmIUsedList.push({
                  value:scope.name
                })
              }
            })
          });
        }
        this.isWhereAmIUsedModalVisible=true;
      })
  }

  closeWhereAmIUsedModal(isCloseWhereAmIModal:boolean){
    this.whereAmIUsedList=[];
    this.isWhereAmIUsedModalVisible=isCloseWhereAmIModal;
  }

  addOrEditDocumentTemplate = (documentTemplateId: string): void => {
    if (documentTemplateId.trim().length > 0) {
      this.documentTemplateToEdit = this.documentTemplates.find((template) => {
        return template.documentTemplateId === documentTemplateId;
      })
    } else {
      this.documentTemplateToEdit = undefined;
    }
    this.isDocumentTemplateSliderOpen = !this.isDocumentTemplateSliderOpen;
  }
  getDocumentTemplates = () => {
    this.showLoader = true;
    this.documentTemplateManagementService.getDocumentTemplates().subscribe((documentTemplates) => {
      this.bindDocumentTemplates(documentTemplates);
      this.showLoader = false;
    })
  }
  bindDocumentTemplates = (documentTemplates: DocumentTemplateDetails[]) => {
    this.documentTemplatesModalInput.lists = documentTemplates;
    this.documentTemplates = cloneDeep(documentTemplates);
    this.documentTemplatesModalInput.filters = this.getFiltersForDocumentTemplateList();
    this.documentTemplatesModalInput.sort = this.getSortFieldsForDocumentTemplateList();
    this.documentTemplatesModalInput.clearSelection = true;
    this.isDocumentTemplatesLoaded = !this.commonService.IsListEmpty(this.documentTemplatesModalInput.lists);
    this.documentTemplatesModalInput = { ...this.documentTemplatesModalInput };
  }
  closeDocumentTemplateSlider(isSliderActive: boolean) {
    this.isDocumentTemplateSliderOpen = isSliderActive;
  }
  openDeleteConfirmationModal = (documentTemplateId: string) => {
    this.confirmationService.confirm({
      header: DocumentTemplateManagementConstants.Document_Template_Management_Confirmation_Header,
      message: DocumentTemplateManagementConstants.Document_Template_DeActivate_Confirmation_Message,
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.deActiveDocumentTemplate(documentTemplateId);
      },
    });
  }

  downloadFile = (fileId: string, fileName: string) => {
    this.fileService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }
  calculateIsActiveColor = (isActive: string): string => {
    return isActive === this.isActiveValueYes ? 'is_Active_Yes' : 'is_Active_No';
  }
  private getFiltersForDocumentTemplateList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'Is Active',
        filterFieldName: 'isActive',
      }
    );
    return filters;
  };
  private getSortFieldsForDocumentTemplateList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'Name',
        sortFieldName: 'name',
      },
      {
        sortFieldDisplayName: 'Is Active',
        sortFieldName: 'isActive',
      }
    );
    return sortMenu;
  };
  private deActiveDocumentTemplate = (documentTemplateId: string) => {
    this.documentTemplateManagementInteractionService.removeScopeSelection();
    this.documentTemplateManagementService.
      deActiveDocumentTemplate(documentTemplateId).subscribe(_ => {
        setTimeout(() => {
          this.documentTemplateManagementInteractionService.refreshDocumentTemplates();
        }, 2000);
      })
  }

}
